<div class="flex flex-col gap-4">
  <div class="border border-surface-200 dark:border-surface-800 rounded-xl overflow-hidden shadow-sm">
    <p-accordion [value]="activeIndex()" (valueChange)="activeIndex.set($event)">
      @for (group of formArray().controls; track $index; let i = $index) {
        <p-accordion-panel [value]="i">
          <p-accordion-header>
            <div class="flex items-center justify-between w-full pr-4">
              <span class="font-medium text-surface-700 dark:text-surface-200">
                {{ headerLabel(i) }}
              </span>
              @if (formArray().length > 1) {
                <span
                  class="pi pi-trash text-red-500 cursor-pointer p-2 hover:bg-red-100 dark:hover:bg-red-900/40 rounded-full transition-colors"
                  (mousedown)="$event.stopPropagation()"
                  (click)="onDeleteClick(i, $event)"
                  pTooltip="Remove {{ entityName() }}"
                  tooltipPosition="left">
                </span>
              }
            </div>
          </p-accordion-header>

          <p-accordion-content>
            <div [formGroup]="$any(group)" class="grid grid-cols-1 md:grid-cols-3 gap-4 py-2">
              @for (field of fields(); track field.key) {
                <app-form-field
                  [label]="field.label"
                  [control]="getControl(i, field.key)"
                  [class]="colClass(field)">

                  @switch (field.type) {
                    @case ('textarea') {
                      <textarea pInputText [formControlName]="field.key"
                        [placeholder]="field.placeholder || ''" class="w-full min-h-[80px]">
                      </textarea>
                    }
                    @case ('number') {
                      <p-inputnumber [formControlName]="field.key"
                        [placeholder]="field.placeholder || ''" class="w-full" />
                    }
                    @case ('select') {
                      <p-select [formControlName]="field.key"
                        [options]="getOptions(field)" optionLabel="label" optionValue="value"
                        appendTo="body" class="w-full" />
                    }
                    @case ('multiselect') {
                      <p-multiselect [formControlName]="field.key"
                        [options]="getOptions(field)" optionLabel="label" optionValue="value"
                        appendTo="body" class="w-full" />
                    }
                    @case ('radio-group') {
                      <div class="flex flex-wrap gap-3 pt-1">
                        @for (opt of getOptions(field); track opt.value) {
                          <div class="flex items-center gap-2">
                            <p-radiobutton [formControlName]="field.key" [value]="opt.value"
                              [inputId]="field.key + '_' + opt.value" />
                            <label [for]="field.key + '_' + opt.value" class="text-sm cursor-pointer">{{ opt.label }}</label>
                          </div>
                        }
                      </div>
                    }
                    @case ('checkbox-group') {
                      <div class="flex flex-wrap gap-3 pt-1">
                        @for (opt of getOptions(field); track opt.value) {
                          <div class="flex items-center gap-2">
                            <p-checkbox [formControlName]="field.key" [value]="opt.value"
                              [inputId]="field.key + '_' + opt.value" />
                            <label [for]="field.key + '_' + opt.value" class="text-sm cursor-pointer">{{ opt.label }}</label>
                          </div>
                        }
                      </div>
                    }
                    @case ('date') {
                      <p-datepicker [formControlName]="field.key"
                        [placeholder]="field.placeholder || 'Select date'"
                        [showIcon]="true" iconDisplay="input" appendTo="body" class="w-full" />
                    }
                    @case ('toggle') {
                      <p-toggleswitch [formControlName]="field.key" />
                    }
                    @default {
                      <input pInputText [formControlName]="field.key"
                        [placeholder]="field.placeholder || ''" class="w-full" />
                    }
                  }
                </app-form-field>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>

  <div class="flex justify-center mt-2">
    <button
      pButton
      type="button"
      [label]="'Add ' + entityName()"
      icon="pi pi-plus"
      class="p-button-outlined p-button-primary w-full border-dashed"
      (click)="onAdd()">
    </button>
  </div>
</div>
